import { ASET_PAGE, SPECTRUM_PAGE } from '@/common/constants/pages';
import useStore from '@/common/hooks/useStore';
import Notifier from '@/common/services/Notifier';
import Storage, { KEY_ASET_PENDING_TASKS, KEY_SPECTRUM_PENDING_TASKS } from '@/common/services/Storage';
import SpectrumAPI from '@/spectrum/api/SpectrumAPI';
import { generateSuccessMessage } from '@/spectrum/helpers/generateTaskMessage';
import { PendingTasksService } from '@/spectrum/services/PendingTasksService';
const PENDING_GROUP_PAGE_MAP = {
    [KEY_ASET_PENDING_TASKS]: ASET_PAGE,
    [KEY_SPECTRUM_PENDING_TASKS]: SPECTRUM_PAGE,
};
const LISTENER_TIMEOUT = 5000;
export default class PendingSpectrumTasksStore {
    listenerTimeout;
    spectrumAPI;
    constructor() {
        this.spectrumAPI = new SpectrumAPI();
    }
    listen() {
        this.listener();
    }
    ignore() {
        clearTimeout(this.listenerTimeout);
    }
    listener = () => {
        // listener is always running and checking if there are any pending task in local storage
        clearTimeout(this.listenerTimeout);
        this.listenerTimeout = setTimeout(() => {
            const pendingTasksByGroup = PendingTasksService.pendingTasksByGroup();
            // check that "localStorage" has pending tasks,
            // if not - rerun listener, user might add tasks later
            if (Object.keys(pendingTasksByGroup).length === 0) {
                this.listener();
                return;
            }
            this.spectrumAPI
                .fetchModels()
                .then((response) => {
                Object.keys(pendingTasksByGroup).forEach((key) => {
                    pendingTasksByGroup[key]?.forEach((id) => {
                        const model = response.content.find(({ jobId }) => jobId === id);
                        if (model && !model.demo && model.model && model.productId) {
                            Storage.pullout(key, id, Storage.STORAGE_LOCAL);
                            Notifier.success(generateSuccessMessage(PENDING_GROUP_PAGE_MAP[key], model), {
                                // always show until user make some action
                                delay: 0,
                            });
                        }
                    });
                });
            })
                .catch(() => {
                // do nothing
            })
                .finally(() => this.listener());
        }, LISTENER_TIMEOUT);
    };
}
export const usePendingSpectrumTasksStore = () => useStore(PendingSpectrumTasksStore);
export const pendingSpectrumTasksStore = new PendingSpectrumTasksStore();
